import { NEUTRAL } from "../theme/tokens";
import type { WeekData } from "./models";

type WeekSummaryProperty = "weekLoad" | "weekSeason" | "workForce";

/** A planning week's High or Low summary as its colour; anything else, or no week, reads as neutral. */
export const weekPropertyColor = (week: WeekData | undefined, property: WeekSummaryProperty): string => {
	if (week?.[property] === "High") return "#FFA96A";
	if (week?.[property] === "Low") return "#5EB8F9";
	return NEUTRAL[500];
};
